export type Locale = 'en' | 'zh'
export const LOCALE_KEY = 'ow-locale'
export function resolveLocale(
	query: string | null | undefined,
	saved: string | null | undefined
): Locale {
	return query === 'en' || query === 'zh' ? query : saved === 'zh' ? 'zh' : 'en'
}
